import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { clickGAEvent } from 'src/app/_helpers/ga-events';
import { pageLoadEvent } from 'src/app/_helpers/ga-events';
import { addGAEventListener, removeGAEventListener } from 'src/app/_helpers/ga-events';
import { Observable, Observer, Subscription, timer } from 'rxjs';
import * as Sentry from "@sentry/angular-ivy";
declare var zcAction:any;
const countryList = [ 
  {"name": "Afghanistan", "code": "AF"}, 
  {"name": "land Islands", "code": "AX"}, 
  {"name": "Albania", "code": "AL"}, 
  {"name": "Algeria", "code": "DZ"}, 
  {"name": "American Samoa", "code": "AS"}, 
  {"name": "AndorrA", "code": "AD"}, 
  {"name": "Angola", "code": "AO"}, 
  {"name": "Anguilla", "code": "AI"}, 
  {"name": "Antarctica", "code": "AQ"}, 
  {"name": "Antigua and Barbuda", "code": "AG"}, 
  {"name": "Argentina", "code": "AR"}, 
  {"name": "Armenia", "code": "AM"}, 
  {"name": "Aruba", "code": "AW"}, 
  {"name": "Australia", "code": "AU"}, 
  {"name": "Austria", "code": "AT"}, 
  {"name": "Azerbaijan", "code": "AZ"}, 
  {"name": "Bahamas", "code": "BS"}, 
  {"name": "Bahrain", "code": "BH"}, 
  {"name": "Bangladesh", "code": "BD"}, 
  {"name": "Barbados", "code": "BB"}, 
  {"name": "Belarus", "code": "BY"}, 
  {"name": "Belgium", "code": "BE"}, 
  {"name": "Belize", "code": "BZ"}, 
  {"name": "Benin", "code": "BJ"}, 
  {"name": "Bermuda", "code": "BM"}, 
  {"name": "Bhutan", "code": "BT"}, 
  {"name": "Bolivia", "code": "BO"}, 
  {"name": "Bosnia and Herzegovina", "code": "BA"}, 
  {"name": "Botswana", "code": "BW"}, 
  {"name": "Bouvet Island", "code": "BV"}, 
  {"name": "Brazil", "code": "BR"}, 
  {"name": "British Indian Ocean Territory", "code": "IO"}, 
  {"name": "Brunei Darussalam", "code": "BN"}, 
  {"name": "Bulgaria", "code": "BG"}, 
  {"name": "Burkina Faso", "code": "BF"}, 
  {"name": "Burundi", "code": "BI"}, 
  {"name": "Cambodia", "code": "KH"}, 
  {"name": "Cameroon", "code": "CM"}, 
  {"name": "Canada", "code": "CA"}, 
  {"name": "Cape Verde", "code": "CV"}, 
  {"name": "Cayman Islands", "code": "KY"}, 
  {"name": "Central African Republic", "code": "CF"}, 
  {"name": "Chad", "code": "TD"}, 
  {"name": "Chile", "code": "CL"}, 
  {"name": "China", "code": "CN"}, 
  {"name": "Christmas Island", "code": "CX"}, 
  {"name": "Cocos (Keeling) Islands", "code": "CC"}, 
  {"name": "Colombia", "code": "CO"}, 
  {"name": "Comoros", "code": "KM"}, 
  {"name": "Congo", "code": "CG"}, 
  {"name": "Congo, The Democratic Republic of the", "code": "CD"}, 
  {"name": "Cook Islands", "code": "CK"}, 
  {"name": "Costa Rica", "code": "CR"}, 
  {"name": "Cote D'Ivoire", "code": "CI"}, 
  {"name": "Croatia", "code": "HR"}, 
  {"name": "Cuba", "code": "CU"}, 
  {"name": "Cyprus", "code": "CY"}, 
  {"name": "Czech Republic", "code": "CZ"}, 
  {"name": "Denmark", "code": "DK"}, 
  {"name": "Djibouti", "code": "DJ"}, 
  {"name": "Dominica", "code": "DM"}, 
  {"name": "Dominican Republic", "code": "DO"}, 
  {"name": "Ecuador", "code": "EC"}, 
  {"name": "Egypt", "code": "EG"}, 
  {"name": "El Salvador", "code": "SV"}, 
  {"name": "Equatorial Guinea", "code": "GQ"}, 
  {"name": "Eritrea", "code": "ER"}, 
  {"name": "Estonia", "code": "EE"}, 
  {"name": "Ethiopia", "code": "ET"}, 
  {"name": "Falkland Islands (Malvinas)", "code": "FK"}, 
  {"name": "Faroe Islands", "code": "FO"}, 
  {"name": "Fiji", "code": "FJ"}, 
  {"name": "Finland", "code": "FI"}, 
  {"name": "France", "code": "FR"}, 
  {"name": "French Guiana", "code": "GF"}, 
  {"name": "French Polynesia", "code": "PF"}, 
  {"name": "French Southern Territories", "code": "TF"}, 
  {"name": "Gabon", "code": "GA"}, 
  {"name": "Gambia", "code": "GM"}, 
  {"name": "Georgia", "code": "GE"}, 
  {"name": "Germany", "code": "DE"}, 
  {"name": "Ghana", "code": "GH"}, 
  {"name": "Gibraltar", "code": "GI"}, 
  {"name": "Greece", "code": "GR"}, 
  {"name": "Greenland", "code": "GL"}, 
  {"name": "Grenada", "code": "GD"}, 
  {"name": "Guadeloupe", "code": "GP"}, 
  {"name": "Guam", "code": "GU"}, 
  {"name": "Guatemala", "code": "GT"}, 
  {"name": "Guernsey", "code": "GG"}, 
  {"name": "Guinea", "code": "GN"}, 
  {"name": "Guinea-Bissau", "code": "GW"}, 
  {"name": "Guyana", "code": "GY"}, 
  {"name": "Haiti", "code": "HT"}, 
  {"name": "Heard Island and Mcdonald Islands", "code": "HM"}, 
  {"name": "Holy See (Vatican City State)", "code": "VA"}, 
  {"name": "Honduras", "code": "HN"}, 
  {"name": "Hong Kong", "code": "HK"}, 
  {"name": "Hungary", "code": "HU"}, 
  {"name": "Iceland", "code": "IS"}, 
  {"name": "India", "code": "IN"}, 
  {"name": "Indonesia", "code": "ID"}, 
  {"name": "Iran, Islamic Republic Of", "code": "IR"}, 
  {"name": "Iraq", "code": "IQ"}, 
  {"name": "Ireland", "code": "IE"}, 
  {"name": "Isle of Man", "code": "IM"}, 
  {"name": "Israel", "code": "IL"}, 
  {"name": "Italy", "code": "IT"}, 
  {"name": "Jamaica", "code": "JM"}, 
  {"name": "Japan", "code": "JP"}, 
  {"name": "Jersey", "code": "JE"}, 
  {"name": "Jordan", "code": "JO"}, 
  {"name": "Kazakhstan", "code": "KZ"}, 
  {"name": "Kenya", "code": "KE"}, 
  {"name": "Kiribati", "code": "KI"}, 
  {"name": "Korea, Democratic People'S Republic of", "code": "KP"}, 
  {"name": "Korea, Republic of", "code": "KR"}, 
  {"name": "Kuwait", "code": "KW"}, 
  {"name": "Kyrgyzstan", "code": "KG"}, 
  {"name": "Lao People'S Democratic Republic", "code": "LA"}, 
  {"name": "Latvia", "code": "LV"}, 
  {"name": "Lebanon", "code": "LB"}, 
  {"name": "Lesotho", "code": "LS"}, 
  {"name": "Liberia", "code": "LR"}, 
  {"name": "Libyan Arab Jamahiriya", "code": "LY"}, 
  {"name": "Liechtenstein", "code": "LI"}, 
  {"name": "Lithuania", "code": "LT"}, 
  {"name": "Luxembourg", "code": "LU"}, 
  {"name": "Macao", "code": "MO"}, 
  {"name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"}, 
  {"name": "Madagascar", "code": "MG"}, 
  {"name": "Malawi", "code": "MW"}, 
  {"name": "Malaysia", "code": "MY"}, 
  {"name": "Maldives", "code": "MV"}, 
  {"name": "Mali", "code": "ML"}, 
  {"name": "Malta", "code": "MT"}, 
  {"name": "Marshall Islands", "code": "MH"}, 
  {"name": "Martinique", "code": "MQ"}, 
  {"name": "Mauritania", "code": "MR"}, 
  {"name": "Mauritius", "code": "MU"}, 
  {"name": "Mayotte", "code": "YT"}, 
  {"name": "Mexico", "code": "MX"}, 
  {"name": "Micronesia, Federated States of", "code": "FM"}, 
  {"name": "Moldova, Republic of", "code": "MD"}, 
  {"name": "Monaco", "code": "MC"}, 
  {"name": "Mongolia", "code": "MN"}, 
  {"name": "Montenegro", "code": "ME"},
  {"name": "Montserrat", "code": "MS"},
  {"name": "Morocco", "code": "MA"}, 
  {"name": "Mozambique", "code": "MZ"}, 
  {"name": "Myanmar", "code": "MM"}, 
  {"name": "Namibia", "code": "NA"}, 
  {"name": "Nauru", "code": "NR"}, 
  {"name": "Nepal", "code": "NP"}, 
  {"name": "Netherlands", "code": "NL"}, 
  {"name": "Netherlands Antilles", "code": "AN"}, 
  {"name": "New Caledonia", "code": "NC"}, 
  {"name": "New Zealand", "code": "NZ"}, 
  {"name": "Nicaragua", "code": "NI"}, 
  {"name": "Niger", "code": "NE"}, 
  {"name": "Nigeria", "code": "NG"}, 
  {"name": "Niue", "code": "NU"}, 
  {"name": "Norfolk Island", "code": "NF"}, 
  {"name": "Northern Mariana Islands", "code": "MP"}, 
  {"name": "Norway", "code": "NO"}, 
  {"name": "Oman", "code": "OM"}, 
  {"name": "Pakistan", "code": "PK"}, 
  {"name": "Palau", "code": "PW"}, 
  {"name": "Palestinian Territory, Occupied", "code": "PS"}, 
  {"name": "Panama", "code": "PA"}, 
  {"name": "Papua New Guinea", "code": "PG"}, 
  {"name": "Paraguay", "code": "PY"}, 
  {"name": "Peru", "code": "PE"}, 
  {"name": "Philippines", "code": "PH"}, 
  {"name": "Pitcairn", "code": "PN"}, 
  {"name": "Poland", "code": "PL"}, 
  {"name": "Portugal", "code": "PT"}, 
  {"name": "Puerto Rico", "code": "PR"}, 
  {"name": "Qatar", "code": "QA"}, 
  {"name": "Reunion", "code": "RE"}, 
  {"name": "Romania", "code": "RO"}, 
  {"name": "Russian Federation", "code": "RU"}, 
  {"name": "RWANDA", "code": "RW"}, 
  {"name": "Saint Helena", "code": "SH"}, 
  {"name": "Saint Kitts and Nevis", "code": "KN"}, 
  {"name": "Saint Lucia", "code": "LC"}, 
  {"name": "Saint Pierre and Miquelon", "code": "PM"}, 
  {"name": "Saint Vincent and the Grenadines", "code": "VC"}, 
  {"name": "Samoa", "code": "WS"}, 
  {"name": "San Marino", "code": "SM"}, 
  {"name": "Sao Tome and Principe", "code": "ST"}, 
  {"name": "Saudi Arabia", "code": "SA"}, 
  {"name": "Senegal", "code": "SN"}, 
  {"name": "Serbia", "code": "RS"}, 
  {"name": "Seychelles", "code": "SC"}, 
  {"name": "Sierra Leone", "code": "SL"}, 
  {"name": "Singapore", "code": "SG"}, 
  {"name": "Slovakia", "code": "SK"}, 
  {"name": "Slovenia", "code": "SI"}, 
  {"name": "Solomon Islands", "code": "SB"}, 
  {"name": "Somalia", "code": "SO"}, 
  {"name": "South Africa", "code": "ZA"}, 
  {"name": "South Georgia and the South Sandwich Islands", "code": "GS"}, 
  {"name": "Spain", "code": "ES"}, 
  {"name": "Sri Lanka", "code": "LK"}, 
  {"name": "Sudan", "code": "SD"}, 
  {"name": "Suriname", "code": "SR"}, 
  {"name": "Svalbard and Jan Mayen", "code": "SJ"}, 
  {"name": "Swaziland", "code": "SZ"}, 
  {"name": "Sweden", "code": "SE"}, 
  {"name": "Switzerland", "code": "CH"}, 
  {"name": "Syrian Arab Republic", "code": "SY"}, 
  {"name": "Taiwan, Province of China", "code": "TW"}, 
  {"name": "Tajikistan", "code": "TJ"}, 
  {"name": "Tanzania, United Republic of", "code": "TZ"}, 
  {"name": "Thailand", "code": "TH"}, 
  {"name": "Timor-Leste", "code": "TL"}, 
  {"name": "Togo", "code": "TG"}, 
  {"name": "Tokelau", "code": "TK"}, 
  {"name": "Tonga", "code": "TO"}, 
  {"name": "Trinidad and Tobago", "code": "TT"}, 
  {"name": "Tunisia", "code": "TN"}, 
  {"name": "Turkey", "code": "TR"}, 
  {"name": "Turkmenistan", "code": "TM"}, 
  {"name": "Turks and Caicos Islands", "code": "TC"}, 
  {"name": "Tuvalu", "code": "TV"}, 
  {"name": "Uganda", "code": "UG"}, 
  {"name": "Ukraine", "code": "UA"}, 
  {"name": "United Arab Emirates", "code": "AE"}, 
  {"name": "United Kingdom", "code": "GB"}, 
  {"name": "United States", "code": "US"}, 
  {"name": "United States Minor Outlying Islands", "code": "UM"}, 
  {"name": "Uruguay", "code": "UY"}, 
  {"name": "Uzbekistan", "code": "UZ"}, 
  {"name": "Vanuatu", "code": "VU"}, 
  {"name": "Venezuela", "code": "VE"}, 
  {"name": "Viet Nam", "code": "VN"}, 
  {"name": "Virgin Islands, British", "code": "VG"}, 
  {"name": "Virgin Islands, U.S.", "code": "VI"}, 
  {"name": "Wallis and Futuna", "code": "WF"}, 
  {"name": "Western Sahara", "code": "EH"}, 
  {"name": "Yemen", "code": "YE"}, 
  {"name": "Zambia", "code": "ZM"}, 
  {"name": "Zimbabwe", "code": "ZW"} 
  ];

@Component({
  selector: 'app-new-business',
  templateUrl: './new-business.component.html',
  styleUrls: ['./new-business.component.css']
})
export class NewBusinessComponent implements OnInit {
 
  validateForm! : UntypedFormGroup;
  validateForm2! : UntypedFormGroup;
  state: number = 1;
  loading: boolean = false;
  // paramsObject!: any;
  token!: any;
  // businessid!: any;
  // userid!: any;
  industryData: any[] = []; 
  countriesData: any[] = [];
  industryOfSelectedValue: any;
  window: any;
  selectedCountry: any;
  email : any;
  password : any;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private notification: NzNotificationService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit(): void {
    pageLoadEvent("auth-newbusiness_page");
    addGAEventListener();
    // this.route.queryParamMap
    // .subscribe((params) => {
    //     this.paramsObject = {...params };
    //     // this.userid = this.paramsObject.params.uid;
    //     // this.businessid = this.paramsObject.params.bid;
    //     this.token = this.paramsObject.params.token;
    //     this.token && this.authService.saveBusinessToken(this.token);
    //   }
    // );
    this.token = this.route.snapshot.paramMap.get('token');
    this.authService.saveBusinessToken(this.token);
    this.email = this.route.snapshot.paramMap.get('email');
    this.password = this.route.snapshot.paramMap.get('password');
    this.authService.currentCountry.subscribe(response => {
      this.selectedCountry = response;
    },
    (error:any) => {
      Sentry.captureMessage('Error: ' + error);
    });
    zcAction('selfsignup_verification')
    this.validateForm = this.fb.group({
      businessname: [null, [Validators.required]],
      businessaddress: [null, [Validators.required]],
      website: [null, [Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      // country: [null, [Validators.required]],
      industry: [null, [Validators.required]],
    });

    this.validateForm2 = this.fb.group({
      senderidname: [null, [Validators.required, Validators.maxLength(11)]],
      senderiddescription: [null, [Validators.required, Validators.maxLength(160)]],
    });

    this.getAllIndustries();
    // this.getAllCountries();

  }

  ngAfterViewInit(): void {
    removeGAEventListener();
    addGAEventListener();
  }

  ngOnDestroy(): void {
    removeGAEventListener();
  }

  get f() { return this.validateForm.controls; }
  get f2() { return this.validateForm2.controls; }

  submitNewBusiness(){
    if (this.validateForm.valid && this.industryOfSelectedValue && this.selectedCountry) {
    this.loading = true;
    const payload = {
      business_address : this.f.businessaddress.value,
      business_name : this.f.businessname.value,
      business_url : this.f.website.value,
      country: this.selectedCountry,
      industry: this.industryOfSelectedValue,
      token: this.token
    }
    this.authService
    .newBusiness(payload, this.token)
    .pipe(first())
    .subscribe({
      next: (res : any) => {
        this.loading = false;
        let responseData = res;
        zcAction('selfsignup_create_buisness');
        if (!responseData.error) {
          this.analyticsService.businessCreationEvent(true);
          this.createNotification('success','Business created', responseData.response || 'Your new business has been created');
          // this.validateForm.reset();
          this.state = 2;
        }else{
          this.analyticsService.businessCreationEvent(false);
          this.createNotification('error','Error creating Business', responseData.response || 'There was an error creating a new business');
          // this.state = 2;
        }
      },
      error: (error : any) => {
        Sentry.captureMessage('Error: ' + error);
        this.loading = false;
        this.createNotification('error','Error creating Business', 'There was an error creating a new business')
      }
    });
  }
  }

  loginSend(){
    clickGAEvent("route_click","skip-for-now_click","auth-newbusiness_page")
    this.authService.login(this.email, this.password).pipe(first()).subscribe({
      next: (res : any) => {
        if (!res.error) {
          this.analyticsService.loginEvent(true);
          this.router.navigate(['dashboard']);
        }else{
          Sentry.captureMessage('Error: ' + res.error);
          this.analyticsService.loginEvent(false);
          this.router.navigate(['/auth/login']);
        }
      },
      error: (err : any) => {
        Sentry.captureMessage('Error: ' + err);
        if(err.response ?.user ?.account_status == "partially approved"){
          this.router.navigateByUrl(`/auth/newbusiness?token=${err.response.token}`);
        } else {
          this.router.navigate(['/auth/login']);
        }
      }
    });
  }

  submitNewSender(){
    if(!this.f2.senderidname.value || !this.f2.senderiddescription.value ) return;
    this.loading = true;
    const payload = {
      name: this.f2.senderidname.value.trim(),
      ad_copy: this.f2.senderiddescription.value,
    }
    this.authService
    .newSender(payload, this.token)
    .pipe(first())
    .subscribe({
      next: (res : any) => {
        this.loading = false;
        let responseData = res;
        zcAction('selfsignup_create_senderId')
        if (!responseData.error) {
          //notification 
          this.analyticsService.senderIdCreationEvent(true);
          this.notification.create(
            "success",
            "Sender ID Created",
            `${this.f2.senderidname.value} created successfully. Please note that it can take up to 24 to 48 hours to approve a Sender ID.`
          );
          this.validateForm2.reset();
          // this.router.navigate(['/auth/login']);
          this.loginSend();
        }else{
          this.analyticsService.senderIdCreationEvent(false);
          this.notification.create(
            "error",
            "Sender ID creation failed",
            `Sender ID creation was not successfully.`
          );
        }
      },
      error: (error : any) => {
        Sentry.captureMessage('Error: ' + error);
        this.loading = false;
        this.createNotification('error','Error creating Sender ID', 'There was an error creating a new Sender ID');
      }
    });
  }


  createNotification(type: string, title: string, body: string): void {
    this.notification.create(
      type,
      title,
      body
    );
  }


  resetState(){
    clickGAEvent("button_click","previous-step_click","auth-newbusiness_page");
    this.state = 1;
  }

  getAllIndustries(){
    this.authService.getAllIndustries()
    .pipe(first())
    .subscribe({
        next: (res : any) => {
            let responseData = res.response.Items;
            let industryDataValue = responseData.filter((value : any, index : any, self : any) =>
              index === self.findIndex((t : any) => (
                t.industry === value.industry
              ))
            )
            this.industryData = industryDataValue.map((item: any) => ({
              value: item.industry,
              label: this.capitalizeFirstLetter(item.industry)
            }));
        },
        error: (error:any) => {
            Sentry.captureMessage('Error: ' + error);
        }
    });
  }

  capitalizeFirstLetter(string : any) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // getAllCountries(){
  //   this.countriesData = countryList.map((item: any) => ({
  //     value: item.name,
  //     label: item.name
  //   }));
  // }

  countryValues(e : any){
    if(e){
      clickGAEvent("select_country","new-business-country_click" ,"auth-newbusiness_page", e);
    }
  }

  industryValues(e : any){
    if(e){
      clickGAEvent("select_industry","new-business-industry_click" ,"auth-newbusiness_page", e);
    }
  }

  onKeypressEvent(event: any){
    // return event.charCode != 32
    if(event.target.value.length === 0 && event.charCode === 32){
      event.preventDefault();
      return
    }
 }

 triggerGAInput(inputName: string):void{
  clickGAEvent("input_text","new-" + inputName ,"auth-newbusiness_page");
}
  triggerGAFilter(filterName: string):void{
    clickGAEvent("filter_click","new-business-"+ filterName +"_click" ,"auth-newbusiness_page",);
  }
  triggerGAButton(buttonName: string):void{
    clickGAEvent("button_click", "new-business-" + buttonName + "_click", "auth-newbusiness_page")
  }
  triggerGALogin():void{
    clickGAEvent("route_click","login_click","auth-newbusiness_page");
    this.router.navigate(['/auth/login']);
  }

  triggerGAInputTextarea(label: string):void{
    clickGAEvent("input_text", "newbusiness-" + label + "_click","auth-newbusiness_page");
  }
}
